import React, { useEffect, useState } from 'react'
import Style from './successfull.module.scss'
import Logo from '../../../../assets/theme6/quizwall.png'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import SuccesssAnimation from '../Animation/successAnimation'
import authAxios from '../../../../config/authAxios'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import 'swiper/css/pagination';

import { Autoplay, Pagination } from 'swiper/modules';


import 'swiper/css';
import HappySuccess from '../component/HappySuccess'
import BigSuccess from '../component/BigSuccess'

SwiperCore.use([Autoplay, Pagination]);

const Successfull = () => {
  const { challengeID } = useParams();
  const location = useLocation();
  const search = useLocation().search;
  const [historyData, sethistoryData] = useState({})
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // Optional: smooth scrolling animation
  });

  const navigate = useNavigate()
  const reward = new URLSearchParams(search).get('reward') || 10;
  sessionStorage.setItem("lastScreen", window.location.href);

  const [isMission, setIsMission] = useState(
    location.state?.is_mission ?? JSON.parse(sessionStorage.getItem("is_mission") || "false")
  );

  const message = isMission ? "Mission" : "Challenge"


  const fetchHistory = async () => {
    try {
      const response = await authAxios.get(`/users/api/challange-history/${challengeID}`)
      sethistoryData(response?.data?.data)
    } catch (err) {
      console.log("err", err)
    }
  }

  const navigateHanler = () => {
    navigate('/home-challenge', { replace: true })
  }
  const handleShare = () => {
    const challengeName = historyData?.challenge_name || "Quiz Wall"; // fallback
    const appLink = "https://quizwall.io/";

    const shareText = isMission
      ? `Stop scrolling!🛑

I just finished the super-fun ${challengeName} on Quizwall in ${historyData?.time_taken} seconds 🥳 . It's the best way to earn gift cards just for playing quizzes. Give it a shot!

Get started: ${appLink}`
      : `Hey There!! 🙌🏻

I just crushed today's ${challengeName} on Quizwall in ${historyData?.time_taken} seconds beat me if you can and win big rewards !!\nIf you like fun quizzes and earning free gift cards, you should try it!🤑

Play now: ${appLink}`;

    if (navigator.share) {
      navigator.share({
        title: "Quizwall",
        text: shareText,
        // url: appLink,
      })
        .then(() => console.log('Shared successfully'))
        .catch((error) => console.error('Error sharing:', error));
    } else {
      // Fallback for browsers that don’t support Web Share API
      navigator.clipboard.writeText(shareText)
        .then(() => alert("Share text copied to clipboard!"))
        .catch(() => alert("Could not copy share text."));
    }
  };


  useEffect(() => {
    if (location.state?.is_mission !== undefined) {
      sessionStorage.setItem("is_mission", JSON.stringify(location.state.is_mission));
    }
    window.location.hash = window.location.hash + "no-back-button";
    window.location.hash = "Again-No-back-button";
    window.onhashchange = function () {
      window.location.hash = "no-back-button";

    }



    fetchHistory()
  }, [])
  return (
    <>
      <div className={Style.container}>
        <div className={Style.logo}>
          <img src={Logo} width={"130px"} alt="logo" />
        </div>
        <div style={{ position: "absolute", top: "50px" }}>
          <SuccesssAnimation />
        </div>

        <div className={Style.CompletBox}>


          <Swiper
            spaceBetween={50}
            slidesPerView={1}
            style={{
              "--swiper-pagination-bullet-inactive-color": "#FFFFFF",
              "--swiper-pagination-bullet-active-color": "#572e32ff",
              "--swiper-pagination-bullet-inactive-opacity": "1",
              "--swiper-pagination-color": "#352E57"
            }}
            scrollbar={{ draggable: true }}
            loop={true}
            pagination={true}
            modules={[Pagination]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              waitForTransition: 200

            }}
          >
            {/* <SwiperSlide >
              <div className={Style.newReward}>
                <HappySuccess h3Text={`Hurrah!\nChallenge Completed`} />
              </div>
            </SwiperSlide> */}
            <SwiperSlide >
              <div className={Style.newReward}>
                <HappySuccess h3Text={`Hurrah!`} h5Text={`${message} Completed Successfully`} h6Text={`${historyData?.reward} Coins Credited Successfully`} />
              </div>
            </SwiperSlide>
            <SwiperSlide >
              <div className={Style.newReward}>
                <BigSuccess h3Text='TOTAL COINS EARNED' textType="coin" text={`${historyData?.reward}`} />
              </div>
            </SwiperSlide>
            <SwiperSlide >
              <div className={Style.newReward}>
                <BigSuccess h3Text='TOP 20% OF ALL PLAYERS' textType="image" />
              </div>
            </SwiperSlide>
            <SwiperSlide >
              <div className={Style.newReward}>
                <BigSuccess h3Text='Time taken to complete the quiz' textType="time" text={`${historyData?.time_taken}`} />
              </div>
            </SwiperSlide>
          </Swiper>

        </div>
        <div style={{ display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center", marginTop: "30px" }}>
          <button className={Style.btn} onClick={() => { handleShare() }}> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
            <path d="M14 5.83832L5.17647 1.60303M12.2353 10.7795L2 10.7795M14 15.3677L8 18.8971" stroke="white" stroke-width="2.11765" stroke-linecap="round" />
          </svg><p>Share Result</p> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
              <path d="M2 5.83832L10.8235 1.60303M3.76471 10.7795L14 10.7795M2 15.3677L8 18.8971" stroke="white" stroke-width="2.11765" stroke-linecap="round" />
            </svg></button>

          <div className={Style.styleBtn} onClick={() => { navigateHanler() }}><p>SKIP</p></div>

        </div>
      </div>
    </>
  )
}

export default Successfull